<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-separate-window`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26 20V10h16v10H26zM22 8c0-1.105.9-2 2-2h20c1.1 0 2 .895 2 2v14c0 1.105-.9 2-2 2H24c-1.1 0-2-.895-2-2V8zM4 10h14v4H5.976v24h32.043V28H42v12c0 1.105-.886 2-2.003 2H4c-1.096 0-2-.895-2-2V12c0-1.105.873-2 2-2z"/></svg>
</template>
<script>

export default {
  name: 'IconSeparateWindow',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
